import { AbstractControl } from '@angular/forms';
import {
  GasGridConnectionData,
  HeatingGridConnectionData,
  PowerGridConnectionData,
  WaterGridConnectionData,
} from './technician-data/technician-data.domain';
import { DocumentsSectionsState } from '../+grid-application-shared/entities/sections-state/documentsSectionsState';
import { AreaLocation } from '../+grid-application-shared/entities/personal-data/areaLocation';

export interface ComponentFormData {
  component: string;
  formData: AbstractControl;
  index?: number;
  parentIndex?: number;
}

export interface LookUpData {
  lookup: {
    [key: string]: {
      options: LookupOptionsData[];
    };
  };
}

export interface LookupOptionsData {
  label: string;
  order: number;
  value: string;
  inactive?: boolean;
}

export interface GasDeviceDataResponse {
  gasdevicetype: GasDeviceData[];
}

export interface GasDeviceData {
  id: string;
  device_class: string;
  device_type: string;
}

export interface ZipCodeData {
  zipcode: {
    id: string;
    zipcode: string;
    label: string;
  }[];
}

export interface UpdateApplicationStatusRequest {
  building_con_from?: string;
  comment?: string;
  desired_date?: string;
  sk_status?: string;
  applicant_is_landowner?: string;
  applicant_is_invoicerecipient?: string;
  technical_conditions_met?: string;
  chimney_sweeper_id?: string;
  documents_sections_state?: DocumentsSectionsState;
  is_operator_agreement_confirmed?: boolean;
}

export interface UpdateApplicationStatusResponse {
  app_installationapplication: {
    application_date: string;
    application_id: string;
    last_changed: string;
    objective: string;
    sk_installation_type: string;
    sk_status: string;
    technician_id: string;
    chimney_sweeper_id: string;
  }[];
}

export interface ChimneySweeper {
  chimney_sweeper_id: string;
  name: string;
}

export interface GetChimneySweeperResponse {
  chimneysweeper: ChimneySweeper[];
}

export interface CreateInstallationApplicationResponse {
  installationapplication: [
    {
      application_id: string;
    }
  ];
}

export interface CreateGridCompFeedInApplicationResponse {
  application: [
    {
      application_id: string;
    }
  ];
}

export interface CreateFeedInInstallationResponse {
  feedininstallation: [
    {
      installation_id: string;
    }
  ];
}

export interface CreateFeedInConstructorResponse {
  feedinconstructor: {
    constructor_id: string;
  }[];
}

// export interface CreateFeedInInstallerResponse {
//   feedininstaller: {
//     installer_id: string;
//   }[];
// }

export interface DocumentResponse {
  document: {
    document_id: string;
  }[];
}

export interface CheckServiceAvailabilityData {
  city: string;
  district: string;
  zipcode: string;
  street: string;
  street_number: string;
  medium: string;
  business?: string;
  commercial?: string;
  development_area?: string;
  development_area_name?: string;
  sk_development_area_type?: string;
  sk_building_type?: string;
  x: number;
  y: number;
}

export interface CheckServiceAvailabilityResponse {
  regionalstructure: {
    ordnancearea: boolean;
    result: boolean;
  }[];
}

export interface ConnectionObjectResponse {
  connectionobject: {
    connectionobject_id: string;
  }[];
}

export interface UpdateConnectionObjectData {
  connectionobject_id?: string;
  application_id?: string;
  postcode?: string;
  city?: string;
  district?: string;
  street?: string;
  street_no?: string;
  address_suffix?: string;
  residential_unit_count?: string;
  residential_unit_no?: string;
  floor?: string;
  no_street_address?: string;
  building_area_name?: string;
  gps?: string;
  section_name?: string;
  parcel?: string;
  sk_development_area?: string;
  sk_development_area_type?: string;
  development_area_name?: string;
  sws_devarea_subdistrict?: string;
  sws_devarea_parcel?: string;
  sws_devarea_parcel_no?: string;
  sws_devarea_name?: string;

  serialized_custom_fields?: string;
  area_locations?: AreaLocation[];
}

export interface UpdateConnectionObjectResponse {
  connectionobject: UpdateConnectionObjectData[];
}

export interface BusinessPartnerResponse {
  businesspartner: {
    businesspartner_id: string;
  }[];
}

export interface UpdateBusinessPartnerData {
  businesspartner_id?: string;
  application_id?: string;
  firstname?: string;
  company_name?: string;
  lastname?: string;
  phone?: string;
  mobile?: string;
  email?: string;
  postcode?: string;
  city?: string;
  district?: string;
  sk_title?: string;
  street?: string;
  street_no?: string;
  address_suffix?: string;
  con_user_firstname?: string;
  con_user_lastname?: string;
  con_user_phone?: string;
}

export interface UpdateBusinessPartnerResponse {
  businesspartner: UpdateBusinessPartnerData[];
}

export interface BusinessFormData {
  addressSuffix: string;
  city: string;
  email: string;
  firstName: string;
  lastName: string;
  mobile: string;
  telephone: string;
  postCode: string;
  title: string;
  company: string;
  street: string;
  streetNo: string;
  con_user_firstname: string;
  con_user_lastname: string;
  con_user_phone: string;
}

export interface UpdateInstallerData {
  districtheatgridcon: HeatingGridConnectionData;
  gasgridcon: GasGridConnectionData;
  powergridcon: PowerGridConnectionData;
  watergridcon: WaterGridConnectionData;
}

export interface ConnectionObjectFormData {
  addressSuffix: string;
  buildingType: string;
  buildingZone: string;
  city: string;
  district: string;
  floor: string;
  gps: string;
  noAddressCheckbox: boolean;
  parcel: string;
  postCode: string;
  housingUnits: string;
  apartmentNo: string;
  cadastralSection: string;
  street: string;
  streetNo: string;
  swsDevAreaSubDistrict: string;
  swsParcel: string;
  swsParcelNumber: string;
  swsDevAreaName: string;

  customFields: Object;
}

export interface InstallerCompanyFormData {
  company?: string;
  company_city?: string;
  company_firstName?: string;
  company_name?: string;
  company_postCode?: string;
  company_street?: string;
  company_streetNumber?: string;
  company_taxId?: string;
  company_telephone?: string;
  company_telephoneCentral?: string;
  company_title?: string;
  system_company?: string;
  system_city?: string;
  system_firstName?: string;
  system_name?: string;
  system_postCode?: string;
  system_street?: string;
  system_streetNumber?: string;
  system_taxId?: string;
  system_telephone?: string;
  system_telephoneCentral?: string;
  system_title?: string;
}

export interface ConstructorData {
  installation_id?: string;
  postcode?: string;
  city?: string;
  street?: string;
  street_no?: string;
  identification?: string;
  company_name?: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  company_phone?: string;
  sk_title?: string;
}

export interface InstallerData {
  installation_id?: string;
  postcode?: string;
  city?: string;
  street?: string;
  street_no?: string;
  identification?: string;
  company_name?: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  company_phone?: string;
  sk_title?: string;
}

export interface InvoiceAddressResponse {
  invoicerecipient: {
    recipient_id: string;
  }[];
}

export interface UpdateInvoiceAddressData {
  application_id?: string;
  sk_title: string;
  company_name: string;
  firstname: string;
  lastname: string;
  street: string;
  street_no: string;
  address_suffix: string;
  country: string;
  postcode: string;
  phone: string;
  city: string;
  mobile: string;
  recipient_id?: string;
  email?: string;
}

export interface UpdateInvoiceAddressResponse {
  invoicerecipient: UpdateInvoiceAddressData[];
}

export interface InvoiceAddressFormData {
  company?: string;
  id: string;
  title: string;
  firstName: string;
  lastName: string;
  street: string;
  streetNo: string;
  addressSuffix: string;
  city: string;
  postCode: string;
  telephone: string;
  land: string;
  mobile: string;
  email?: string;
}

export interface Facility {
  systemMaxPower?: string;
  systemType?: LookupOptionsData;
}

export interface Generator {
  manufacturer?: string;
  type?: string;
  no_of_units?: string;
  max_power?: string;
}

export interface Inverter {
  manufacturer?: string;
  type?: string;
  no_of_units?: string;
  max_power?: string;
}

export interface FeedInInstallationTechnicalData {
  alreadyExists?: boolean;
  altConcept?: boolean;
  attachments?: Facility[];
  concept?: LookupOptionsData;
  excessEnergy?: boolean;
  feedGrid70?: boolean;
  feedGrid100?: boolean;
  finalConsumers?: boolean;
  generators?: Generator[];
  inverters?: Inverter[];
  islandMode?: boolean;
  price?: string;
  systemPlanned?: boolean;
  compensation_date: Date;
  feedInOperationMode?: string;
  feedInExcess?: string;
  feedInFull?: string;
  otherFeedInValue?: string;
}

export interface FeedInInstallationRequestData {
  application_id?: string;
  sk_feedin_inst_type?: string;
  island_mode?: string;
  feed_in_70?: string;
  generator_device_exists?: string;
  storage_device_planned?: string;
  netconsumer_supply?: string;
  compensation_date?: string;
  sk_feedin_operation_mode?: string;
  sk_feedin_excess_percentage?: string;
  sk_feedin_full_percentage?: string;
  feedin_percentage_other?: string;
  alternative_measuring_concept: string;
  sk_measuring_concept: string;
}

export interface FeedInFaciltyRequestData {
  installation_id?: string;
  sk_feedin_type?: LookupOptionsData;
  max_apparent_power?: string;
}

export interface FeedInInverterRequestData {
  installation_id?: string;
  manufacturer?: string;
  inverter_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface FeedInGeneratorRequestData {
  installation_id?: string;
  manufacturer?: string;
  generator_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface FeedInStorageRequestData {
  installation_id?: string;
  manufacturer?: string;
  storage_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface ConstructorDataObject {
  constructor_id?: string;
  installation_id?: string;
  postcode?: string;
  city?: string;
  street?: string;
  street_no?: string;
  identification?: string;
  company_name?: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  company_phone?: string;
}

export interface InstallerDataObject {
  installer_id?: string;
  installation_id?: string;
  postcode?: string;
  city?: string;
  street?: string;
  street_no?: string;
  identification?: string;
  company_name?: string;
  firstname?: string;
  lastname?: string;
  phone?: string;
  company_phone?: string;
}

export interface FacilityDataObject {
  facility_id: string;
  installation_id: string;
  sk_feedin_type: string;
  max_apparent_power: string;
}

export interface Inverter {
  inverter_id?: string;
  manufacturer?: string;
  inverter_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface Generator {
  generator_id: string;
  manufacturer?: string;
  generator_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface Storage {
  storage_id: string;
  manufacturer?: string;
  storage_type?: string;
  num_identical_units?: string;
  max_apparent_power?: string;
}

export interface FeedInInstallationDataObject {
  installation_id?: string;
  application_id?: string;
  sk_feedin_inst_type?: string;
  sk_feedin_operation_mode?: string;
  generator_device_exists?: string;
  storage_device_planned?: string;
  netconsumer_supply?: string;
  parallel_net_operation?: string;
  sk_measuring_concept?: string;
  alternative_measuring_concept?: string;
  compensation_date?: string;
  sk_feedin_excess_percentage?: string;
  sk_feedin_full_percentage?: string;
  feedin_percentage_other?: string;
  constructor?: ConstructorDataObject;
  installer: InstallerDataObject;
  facility: FacilityDataObject[];
  inverter: Inverter[];
  generator: Generator[];
  storage: Storage[];
}

export class Document {
  constructor(type: string) {
    this.sk_document_type = type;
  }

  document_id: string;
  application_id: string;
  photovoltaic_id?: number;
  inverter_id?: number;
  generator_id?: number;
  converter_id?: number;
  power_plant_protection_id?: number;
  integrated_protection_id?: number;
  sk_document_type: string;
  name: string;
  fileName?: string;
  filename: string;
  content_type: string;
  file: File;
}

export class LocationDetails {
  position: LocationCoordinate;
  roadAccessPosition: LocationCoordinate;
  address: Address;
  formattedAddress: string;
}

export class Address {
  street: string;
  houseNumber: string;
  district: string;
  subDistrict: string;
  city: string;
  postCode: string;
  province: string;
  state: string;
  country: string;
}

export class LocationCoordinate {
  latitude: number;
  longitude: number;
}

export class GridCompTechData {}

export class PowerPlantOperatorAddress {}
